/* eslint-disable prettier/prettier */
import { useMemo } from 'react';

import { useChat } from 'hooks';

export function useChatState(isGroup = false) {
  const { identity, getMessages, getParticipants, getTypingParticipants } = useChat();

  const messages = getMessages(isGroup) as any[];
  const participants = getParticipants(isGroup);
  const typingParticipants = getTypingParticipants(isGroup);

  const typingUserName = useMemo((): string => {
    const typingParticipantIdentity: string | undefined = typingParticipants.find(
      (participant: string) => participant !== identity,
    );

    return typingParticipantIdentity ? participants.get(typingParticipantIdentity) ?? typingParticipantIdentity : '';
  }, [identity, participants, typingParticipants]);

  const chatName = useMemo((): string => {
    if (isGroup && participants.size !== 2) {
      return 'Chat';
    }

    const otherParticipantKey = [...participants.keys()].find((key: string) => key !== identity) ?? '';
    return participants.get(otherParticipantKey) ?? 'Chat';
  }, [identity, isGroup, participants]);

  return { chatName, messages, participants, typingUserName };
}
